import React from "react";

// TODO: add app (tile) properties support
export const Props = () => {
    return (<div className="tile-properties">
    </div>);
}
